export default {
    ja: {
        banner: {
            group1: {
                alt: '',
                href: 'https://www.marunouchi.com/'
            },
            group2: {
                alt: '',
                href: 'https://skyhopbus.com/ja'
            },
        }
    },
    en: {
        banner: {
            group1: {
                alt: '',
                href: 'https://www.marunouchi.com/'
            },
            group2: {
                alt: '',
                href: 'https://skyhopbus.com/'
            },
        }
    },



}